import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';
import TrustScoreDetail from './TrustScoreDetail';
import { getGrade, gradeLabelKo } from '../utils/trustSpeedGrades';

// 2026-05-10 — sidebar mini trust badge (자기 회사 신뢰도)
// Kyle 의도: AUTODEX 어플에서 업체가 자기 등급 보고 다른 업체와 비교
// TS 통일 (2026-07-21) — 매너온도(°) 표시 → 회사 신뢰속도 등급 카드 (GET /trust-speed/me)
// 클릭 → TrustScoreDetail 모달 (재사용)
function OwnTrustBadge(props){
  var userId=props.userId;
  var[speed,setSpeed]=useState(null);
  var[showDetail,setShowDetail]=useState(false);

  useEffect(function(){
    if(!userId)return;
    authFetch(API+'/trust-speed/me')
      .then(function(r){return r.json()})
      .then(function(d){
        if(d&&d.success&&d.data)setSpeed(d.data);
      })
      .catch(function(){/* silent — sidebar mini 라 fail 시 미노출 */});
  },[userId]);

  if(!speed)return null;

  var grade=speed.grade||'IDLE';
  var g=getGrade(grade);
  var kmh=speed.trustSpeed!=null?Math.round(Number(speed.trustSpeed)):0;

  return (
    <React.Fragment>
      <button onClick={function(e){e.stopPropagation();setShowDetail(true)}}
        title="내 신뢰도 상세"
        style={{
          marginTop:6,padding:'5px 8px',
          background:g.color+'22',border:'1px solid '+g.color+'40',borderRadius:6,
          display:'flex',alignItems:'center',gap:6,
          cursor:'pointer',width:'100%',
          color:g.color,fontSize:11,fontWeight:700,
          fontFamily:'inherit',
        }}>
        <span style={{fontSize:13}}>{g.emoji}</span>
        <span style={{flex:1,textAlign:'left'}}>{gradeLabelKo(grade)}</span>
        <span style={{fontVariantNumeric:'tabular-nums'}}>{kmh+' km/h'}</span>
      </button>
      {showDetail&&<TrustScoreDetail userId={userId} onClose={function(){setShowDetail(false)}}/>}
    </React.Fragment>
  );
}

export default OwnTrustBadge;
